var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.76746 57.370531",
    height: 57.370533,
    width: 136.76746,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 17.008,17.008 H 549.92 V 548.274 H 17.008 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath32",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M 0,0 H 566.929 V 793.701 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath114",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m 434.875,726.409 h 124.393 v 62.898 H 434.875 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-596.33105,1035.532)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(528.0609,733.6211)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#c6c6c7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -14.924 l 4.586,12.577 h 7.509 l 4.601,12.572 h -7.527 l 4.59,12.584 H 13.754 L 9.16,25.154 H 21.763 L 17.175,12.572 H 4.565 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.4522,764.069)",
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#e3000b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -12.602 l 4.593,12.58 h -14.919 l -4.591,-12.585 h 12.614 l -4.601,-12.569 h -12.595 l -4.585,-12.581 h 14.923 l 4.565,12.576 h 12.61 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(484.5114,758.1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.461,-1.267 -1.459,-2.858 -3.371,-2.858 -1.913,0 -1.907,1.577 -1.352,2.906 0.52,1.244 1.523,2.814 3.434,2.814 C 0.624,2.862 0.46,1.269 0,0 M 1.869,4.8 1.224,3.348 h -0.05 c -0.449,1.175 -1.632,1.758 -3.347,1.76 -3.703,0.003 -6.004,-1.933 -7.089,-4.913 -0.995,-2.739 0.102,-5.294 3.358,-5.306 1.568,-0.006 3.407,0.334 4.583,1.482 h 0.049 l -0.417,-1.01 c -0.549,-1.51 -1.327,-2.651 -3.384,-2.651 -0.492,0 -0.833,0.052 -1.134,0.235 -0.539,0.38 -0.299,1.087 -0.299,1.087 l -4.472,-0.123 c 0,0 -0.271,-0.752 0.144,-1.672 0.333,-0.736 1.376,-1.78 4.953,-1.78 1.925,0 4.202,0.341 5.82,1.421 1.819,1.22 2.54,2.337 3.254,4.096 L 6.404,4.8 Z",
    style: {
      fill: "#181716",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(468.798,759.0829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -4.315 c 0.521,1.307 1.29,2.123 2.93,2.185 0.725,0.04 1.168,-0.223 1.38,-0.654 C 0.206,1.101 0.201,0.551 0,0 m -0.681,4.125 c -3.882,0 -7.205,-1.611 -8.469,-5.086 -1.475,-4.055 0.692,-5.786 4.785,-5.786 1.447,0 2.986,0.229 4.273,0.799 1.247,0.513 2.393,1.31 3.048,2.481 0.031,0.054 0.06,0.101 0.09,0.157 l -4.179,0.204 c -0.458,-0.948 -1.288,-1.467 -2.735,-1.451 -1.733,0.02 -1.728,1.355 -1.303,2.472 h 8.733 c 1.461,3.53 0.408,6.21 -4.243,6.21",
    style: {
      fill: "#181716",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(458.8063,763.1807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.62,-0.144 -2.814,-0.649 -3.78,-2.07 h -0.049 l 0.59,1.79 h -4.575 l -3.744,-10.259 H -6.9 l 1.429,3.928 c 0.641,1.963 1.762,3.219 4.196,3.24 0.16,0 0.924,-0.063 1.158,-0.145 L 1.388,0.029 C 0.848,0.069 0,0 0,0",
    style: {
      fill: "#181716",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#181716",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 496.4221,754.589 c -0.883,0 -1.438,0.607 -1.233,1.361 0.249,0.913 1.287,1.698 4.427,1.579 -0.5,-1.505 -1.183,-2.94 -3.194,-2.94 m 4.114,8.619 c -1.372,0 -2.961,-0.058 -4.42,-0.533 -2.461,-0.792 -2.956,-2.689 -2.956,-2.689 l 4.225,-0.097 c 0.206,0.731 0.89,1.48 2.027,1.52 1.886,0.061 1.12,-1.386 0.836,-2.144 h -1.471 c -4.02,0 -6.875,-0.662 -7.957,-3.189 -0.443,-1.03 -0.31,-1.988 0.314,-2.766 0.468,-0.582 1.45,-0.996 2.92,-0.996 2.305,0 3.464,0.986 4.294,1.717 h 0.05 l -0.408,-1.39 h 4.237 l 2.487,6.831 c 0.888,2.314 -1.327,3.736 -4.178,3.736"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegaLogo);
export default __webpack_public_path__ + "static/media/rega-logo.1488d5902e54a322dc3aa3523b98c4f0.svg";
export { ForwardRef as ReactComponent };